import { addDays, startOfMonth, subMonths } from '../../../../utils/date';
import { advancedCutoffDate, hasUserCutoff } from './advanced-cutoff-date';

// The +1 day counts a month ending exactly on a user cutoff as closed;
// on the rolling lag the boundary day's data may not be loaded yet
export const lastTransitionDate = startOfMonth(
  subMonths(hasUserCutoff ? addDays(advancedCutoffDate, 1) : advancedCutoffDate, 2)
);
